import { parseOzmapColor } from './geolocationUtils';

export const getOzmapBoxStyle = caixa => {
    const name = (caixa.name || '').toUpperCase();
    const color = name.includes('CTO') ? '#FFFF00'
        : name.includes('CEO') ? '#00FFFF'
            : parseOzmapColor(caixa.color) || '#808080';
    return { radius: 9, fillColor: color, color, weight: 2, opacity: 1, fillOpacity: 0.9 };
};
